import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  donutChart: {
    display: "flex",
    justifyContent: "center",
    "& .k-chart": {
      height: 280,
      width: '100%'
    },
  },
  donutSummary: {
    textAlign: "center",
    "& h2": {
      margin: ' 0 0 10px 0',
      lineHeight: 1,
      fontSize: 14,
      fontFamily: 'Poppins',
    },
    "& h4": {
      margin: 0,
      fontSize: 30,
      lineHeight: 1,
      color: '#4D4F5C',
    },
  },
}));

export default useStyles;
